import React from 'react';
import Takeover from './takeover';
import './styles.scss';

const AltTakeover = props => {
    return (
        <Takeover {...props} modifiers={{'takeover--alt': true}}/>
    );
};

export default AltTakeover;